import { connect } from 'react-redux';
import { Userpilot } from './component';
import { setUserpilotScriptLoaded } from '../../../ReduxStorage/Userpilot/dispatchers';

export const ConnectedUserpilot = connect(null, { setUserpilotScriptLoaded })(
  Userpilot
);
